import React, {Component} from 'react'
import {Grid} from '@material-ui/core'
import ModuleList from './ModuleList/ModuleList'
import {withRouter} from 'react-router'
import { withStyles } from '@material-ui/core/styles';
import {
  request_business,
  request_businesses,
  request_add_employer_registration, 
  request_uploadFile,
  request_downloadFile,
  request_business_documents
} from './requests.jsx'

import FormAModal from '../../../../../components/Modals/FormAModal'
import FileManagerModal from '../../../../../components/Modals/FileManagerModal/FileManagerModal'
import WarningModal from '../../../../../components/Modals/WarningModal'
import CustomSnackbar from '../../../../../components/Snackbars/CustomSnackbar'


import {formData as adddata} from './additem/data' 
import {contentData as addcontent} from './additem/content' 
import {catalog_matrix as addmatrix} from './additem/catalog_matrix'


import {cleanData2Table} from './customFunctions'
import { contentData } from './content'
import SimpleLoader from '../../../../../components/Loaders/SimpleLoader';
import ContentText from '../../../../../components/Texts/ContentText'

const styles = theme => ({
  card:{
    margin: '20px',
    padding: '64px',
    background: 'white'
  }
})

class Associates extends Component {

  state = {
    isloading:false,
    businesses:[],
    business:null,
    associates:[],
    associate_documents:[],
    employers:[],
    selected_item:null,
    users:[],
    modals:{
      additem:{open:false,issending:false,error:null},
      edititem:{open:false,issending:false,error:null, extra:null},
      filemodal:{open:false,issending:false,error:null,extra:null},
      warning_delete_item:{open:false, issending:false, error:null, id:null}
    },
    success:{open:false,timeout:2000,type:'success',message:'Successful action!'},
  }

  componentDidMount(){
    this.initModule()
  }

  initModule = async() => {
    this.setState({isloading:true})
    await this.requestBasicInfoBusinessData()
    this.setState({isloading:false})
  }

  requestBasicInfoBusinessData = async() => {
    const {match} = this.props
    const {id, idbusiness} = match.params
    let response = await request_business(idbusiness)
    this.setState({business:{...response}})
    let associates = [...response.associates]
    response = await request_businesses(id)
    this.setState({businesses:[...response]})
    let associate_info = []
    let i
    for(i=0; i<associates.length;i++){
      let temp = await request_business_documents(associates[i].associate_id)
      associate_info.push(temp)
    }
    this.setState({associate_documents:[...associate_info], associates:[...associates]})
  }

  onSubmitFile = async(filepath, file, data) => {
    try{
      this.onEditModal('filemodal',{issending:true})
      const aux = file[0].name.split('.')
      const ext = {ext:aux[aux.length-1]}
      await request_uploadFile(data.id, filepath, file[0], ext)
      await this.requestBasicInfoBusinessData()
      this.onCloseModal('filemodal')
      this.onActivateSuccessSnack()
    }catch(e){
      this.onEditModal('filemodal',{issending:false})
      if(e.response){
        this.onEditModal('filemodal',{error:e.response.data.error.message})
      }
    }
  }

  onFileActionManager = async(action, data) => {
    if(action === 'upload'){
      this.onOpenFileModal('filemodal',data)
    }else{
      this.onDownloadFile(data)
    }
  }

  onAddItem = async(data, type) => {
    try{
      const {businessID} = this.props
      const redata = {...data, business_id:businessID}
      this.onEditModal(type,{issending:true})
      let response = await request_add_employer_registration(businessID,redata)
      this.setState({associates:[...response]})
      this.onCloseModal(type)
      this.onActivateSuccessSnack()
    }catch(e){
      this.onEditModal(type,{issending:false})
      if(e.response){
        this.onEditModal(type,{error:e.response.data.error.message})
      }
      
    }
  }

  onDownloadFile = async (data) => {
    try{
      await request_downloadFile(data.id, data.path)
    }catch(e){
      console.log(e)
    }
  }

  onItemSelected = (id) => {
    const {employers} = this.state
    let aux = employers.filter(el => el.id_employer_registration === id)
    if(aux.length > 0){
      this.setState({selected_item:aux[0]})
      this.onOpenFileModal('edititem')
    }
  }

  onOpenFileModal = (section, filedata) => {
    const {modals} = this.state
    let tempModals = {...modals}
    tempModals[section].open=true
    if(filedata){
      tempModals[section].data = {...filedata} 
    }
    this.setState({modals:{...tempModals}})
  }

  onCloseModal = (type) => {
    this.onEditModal(type, {open:false, issending:false, error:null})
  }

  onEditModal = (section, data) => {
    const {modals} = this.state;
    let tempModals = {...modals};
    tempModals[section]={...tempModals[section],...data};
    this.setState({modals:{...tempModals}})
  }

  onCloseSnackbar = (id) => {
    let temp = this.state[id]
    temp.open = false
    this.setState({[id]:{...temp}})
  }

  onActivateSuccessSnack = () => {
    const {success} = this.state
    let success_temp = {...success}
    success_temp.open = true
    this.setState({success:{...success_temp}})
  }

  render(){
    const {isloading, employers, modals, success, selected_item, business, businesses,
    associates, associate_documents} = this.state
    const {classes, language, catalogs, permission, permissionsType} = this.props
    const content = contentData[language]
    let contentView = <Grid container justify='center'><Grid item><SimpleLoader /></Grid></Grid>

    let associates_list = cleanData2Table(associates, associate_documents, content.nodata, catalogs)

    if(!isloading){
      contentView = (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ModuleList 
              title={content.tableTitle}
              header={content.header}
              addItem={false}
              data={associates_list}
              onItemSelected={this.onItemSelected}
              onAddItem={() => this.onOpenFileModal('additem')}
              onDeleteItem={this.onPreDeleteItem}
              onFileAction={this.onFileActionManager}
              nodata={content.notable}
              permission={permission}
              permissionsType={permissionsType}
            />
          </Grid>
        </Grid>
      )
    }

    let modalcontent = null

    if(modals.warning_delete_item){
      modalcontent=(
        <WarningModal 
          data={modals.warning_delete_item}
          content={content.modals.warning_delete_item}
          onClose={() => this.onCloseModal('warning_delete_item')}
          onDelete={this.onDeleteItem}
        />
      )
    }

    if(modals.additem.open){
      modalcontent = (
        <FormAModal 
          addSpace={true}
          catalogs={catalogs.business_documents}
          data={modals.additem}
          catalog_matrix={addmatrix}
          content={addcontent[language]}
          form_data={adddata}
          onClose={() => this.onCloseModal('additem')}
          onSubmit={(data) => this.onAddItem(data, 'additem')}

        />
      )
    }

    if(modals.edititem.open){
      modalcontent = (
        <FormAModal 
          origin_data={selected_item}
          addSpace={true}
          catalogs={catalogs.business_documents}
          data={modals.edititem}
          catalog_matrix={addmatrix}
          content={addcontent[language]}
          form_data={adddata}
          onClose={() => this.onCloseModal('edititem')}
          onSubmit={(data) => this.onEditItem(data, 'edititem')}

        />
      )
    }

    if(modals.filemodal.open){
      modalcontent = (
        <FileManagerModal
          data={modals.filemodal}
          open={true}
          language={language}
          onClose={() => this.onCloseModal('filemodal')}
          onSubmit={this.onSubmitFile}
          onDelete={this.onDeleteFile}
        />
      )
    }


    return(
      <div>
        {modalcontent}
        {contentView}
        <CustomSnackbar open={success.open} autoHideDuration={success.timeout} onClose={() => this.onCloseSnackbar(success.type)} message={success.message} variant={success.type}/>
      </div>
    )
  }
}

export default withRouter(withStyles(styles)(Associates))